import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import vuetify from './plugins/vuetify';
import VueChartkick from 'vue-chartkick';
import Chartkick from 'chartkick';
import './plugins';
import './mixins';

import formatDate from './filters/date';
import ApiService from '../src/services/api.service';
import { TokenService } from './services/token.service';
import '@babel/polyfill';

Vue.config.productionTip = false;

Vue.filter('formatDate', formatDate);

Vue.use(VueChartkick, { Chartkick });
// Inicializa  el servicio de API
ApiService.init(process.env.VUE_APP_BASE_URL);
// Inicializa Interceptor
ApiService.mount401Interceptor();
if (TokenService.getToken()) {
  ApiService.setHeader();
}

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app');
